// Module
var code = `<div class="svc-logo-image" data-bind="click: function(m, e) { return true; }, clickBubble: false">
  <input type="file" aria-hidden="true" tabindex="-1" class="svc-choose-file-input" data-bind="attr: { accept: acceptedTypes }">
  <!-- ko ifnot: survey.locLogo.koRenderedHtml -->
  <!-- ko if: allowEdit && !isUploading -->
  <div class="svc-logo-image-placeholder" data-bind="click: chooseFile, key2click">
    <svg>
      <use xlink:href="#icon-image-48x48"></use>
    </svg>
  </div>
  <!-- /ko -->
  <!-- /ko -->
  <!-- ko if: !isUploading && survey.locLogo.koRenderedHtml -->
  <div data-bind="css: containerCss">
    <div class="svc-context-container svc-logo-image-controls">
      <sv-svg-icon class="svc-context-button" data-bind="click: chooseFile, key2click" params="iconName: 'icon-choosefile', size: 'auto'"></sv-svg-icon>
      <sv-svg-icon class="svc-context-button svc-context-button--danger" data-bind="click: remove, key2click" params="iconName: 'icon-clear', size: 'auto'"></sv-svg-icon>
    </div>
    <!-- ko component: { name: 'sv-logo-image', params: survey } -->
    <!-- /ko -->
  </div>
  <!-- /ko -->
  <!-- ko if: isUploading -->
  <div class="svc-logo-image__loading">
    <!-- ko component: { name: 'sv-loading-indicator' } -->
    <!-- /ko -->
  </div>
  <!-- /ko -->
</div>`;
// Exports
export default code;